/** Blocks any key that is not an Arabic/Latin letter or whitespace. */
export const onlyLetters = (event: KeyboardEvent): boolean => {
    if (event.key.length > 1) {
        return true;
    }

    const isLetterOrSpace = /^[A-Za-z\u0600-\u06FF\s]$/.test(event.key);
    if (!isLetterOrSpace) {
        event.preventDefault();
    }

    return isLetterOrSpace;
};
